import {
  Card,
  CardHeader,
  CardBody,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";

const FilterLimitSection = ({ count, handleLimitChange }) => {
  return (
    <Card className="border shadow bg-white">
      <CardHeader className="p-2">
        <h5 className="text-uppercase mb-0 text-medium">Limit To</h5>
      </CardHeader>
      <CardBody className="p-2">
        <InputGroup>
          <Input
            value={count}
            placeholder="Enter Record Limit"
            type="number"
            onChange={handleLimitChange}
          />
          <InputGroupAddon addonType="append">
            <InputGroupText>Records</InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </CardBody>
    </Card>
  );
};

export default FilterLimitSection;
